// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-page {\n}\n.posts-wrapper {\n  width: 100%;\n  max-width: 800px;\n}\n", ""]);
// Exports
module.exports = exports;
